module.exports = __webpack_public_path__ + "img/vision.8c949c39.png";